import { FunctionComponent } from 'react'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { IInfoCenterNewsItem } from 'types/info-center/news'
import { formatTimeStampToStandartDate } from 'hooks/date/formattedTime'

const thumbnail = require('assets/images/news-thumbnail.jpeg')

interface Props {
  news: IInfoCenterNewsItem
}

export const NewsCard: FunctionComponent<Props> = ({ news }) => {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        '&:hover p:not(:first-of-type)': {
          color: '#387d71',
        },
        cursor: 'pointer',
      }}
      onClick={() => navigate(`/news/${news.id}`)}
    >
      <Box
        sx={{
          overflow: 'hidden',
          borderRadius: '4px',
          background: '#f1f2f4',
          height: '128px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '&:hover img': {
            transform: 'scale(1.2)',
          },
        }}
      >
        <Box
          component="img"
          alt="thumbnail"
          sx={{
            maxWidth: '100%',
            width: '100%',
            height: '100%',
            transition: 'transform 0.6s ease',
            objectFit: 'cover',
          }}
          src={thumbnail}
        />
      </Box>
      <Box
        sx={{
          paddingTop: '12px',
        }}
      >
        <Typography variant="caption">
          {formatTimeStampToStandartDate(news.publishedAt)}
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px',
            color: 'primary',
          }}
        >
          {news.title}
        </Typography>
      </Box>
    </Box>
  )
}
